import React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import styled from "styled-components"
import { breakpoints } from "../../../theme"

const Wrapper = styled.div`
  border-left: 2px solid #e6e9ee;
`
const Tab = styled(Link)`
  display: flex;
  text-decoration: none;
  width: 100%;
  flex-direction: column;
  position: relative;
  text-align: start;
  cursor: pointer;
  padding: 19px 10px;
  color: currentColor;
  font-weight: 300;
  font-size: 15px;
  line-height: 131.5%;
  letter-spacing: 0.003em;
  border: none;
  border-bottom: 1px solid var(--light-grey);
  :last-child {
    border: 0;
  }
  @media (min-width: ${breakpoints.medium}px) {
    padding: 25px 10px;
    font-size: 15px;
  }

  &.active {
    background: #f8f8f8;
    border-left: 2px solid var(--primary);

    &:before {
      content: "";
      display: block;
      width: 10px;
      height: 10px;
      position: absolute;
      top: 32px;
      right: 20px;
      border-radius: 50%;
      transform: translate(-250%; 40%);
      background-color: var(--page-color);
    }
  }
`

const SideMenu = ({ tabs }) => {
  return (
    <Wrapper>
      {tabs.map((item, i) => (
        <Tab
          key={i}
          to={item.to}
          activeClassName="active"
          partiallyActive={true}
        >
          {item.title}
        </Tab>
      ))}
    </Wrapper>
  )
}

SideMenu.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      to: PropTypes.string,
    })
  ),
}

export { SideMenu }
